import generalCodeMessages from "@/utils/responseMessages/generalCodeMessages"
import checkoutCodeMessages from "@/utils/responseMessages/checkoutCodeMessages"
import profileCodeMessages from "@/utils/responseMessages/profileCodeMessages"

export default {
	...generalCodeMessages,
	...checkoutCodeMessages,
	...profileCodeMessages
}
